import { useCallback } from 'react'
import { useRouter } from 'next/router'
import { OnlinePaymentProvider } from '@ancon/wildcat-types'

import useAppStore from '../../../store/hooks/useAppStore'
import useAppDispatch from '../../../store/hooks/useAppDispatch'
import {
  payAndGoOnlinePaymentProviderSelector,
  payAndGoOwnCheckDetailsSelector,
  payAndGoPaymentParamsSelector,
} from '../store/payAndGoSelectors'
import { checkIsPaymentInProgressSelector } from '../../check/store/checkSelectors'
import { setPayAndGoConfirmCancelModalView } from '../store/payAndGoSlice'
import { PayAndGoConfirmCancelModalView } from '../types'
import {
  cancelPayAndGoPayment,
  fetchPayAndGoGroup,
  mergeBackExtractedPayAndGoCheck,
} from '../store/payAndGoThunks'
import isExtractedPayAndGoCheck from '../utils/isExtractedPayAndGoCheck'
import { AppRoutes } from '../../app/constants'
import logger from '../../../utils/logger'

async function cancelSurfboardPayment() {
  try {
    const paymentAttempt =
      await window.SurfboardOnlineSDK.order.getPaymentAttempt()

    if (paymentAttempt != null) {
      await paymentAttempt.cancelPayment()
    }
  } catch (err) {
    logger.error('Cancel Surfboard payment failed', err)
  }
}

function usePayAndGoMergeBack() {
  const store = useAppStore()

  const dispatch = useAppDispatch()

  const router = useRouter()

  const mergeBack = useCallback(async () => {
    const params = payAndGoPaymentParamsSelector(store.getState())
    const ownCheck = payAndGoOwnCheckDetailsSelector(store.getState())
    const onlinePaymentProvider = payAndGoOnlinePaymentProviderSelector(
      store.getState(),
    )

    const isPaymentInProgress = checkIsPaymentInProgressSelector(
      store.getState(),
    )

    if (params && ownCheck) {
      dispatch(
        setPayAndGoConfirmCancelModalView(PayAndGoConfirmCancelModalView.None),
      )

      if (isPaymentInProgress) {
        switch (onlinePaymentProvider) {
          case OnlinePaymentProvider.Adyen:
            await dispatch(cancelPayAndGoPayment())
            break

          case OnlinePaymentProvider.Surfboard:
            await cancelSurfboardPayment()
            break

          default:
            break
        }
      }

      if (isExtractedPayAndGoCheck(ownCheck)) {
        dispatch(mergeBackExtractedPayAndGoCheck()).then(() => {
          if (ownCheck.groupId) {
            dispatch(
              fetchPayAndGoGroup({
                outletId: params.outletId,
                groupId: ownCheck.groupId,
              }),
            )
          }
        })
      } else if (ownCheck.groupId) {
        dispatch(
          fetchPayAndGoGroup({
            outletId: params.outletId,
            groupId: ownCheck.groupId,
          }),
        )
      }

      if (window.location.hostname.startsWith('sb.')) {
        const url = new URL(window.location.origin)
        url.hostname = url.hostname.substring(3)
        url.pathname = `/pay-and-go/${params.outletId}/group/${ownCheck.groupId}`

        window.location.href = url.toString()
      } else {
        await router.push({
          pathname: AppRoutes.PayAndGoGroup,
          query: {
            outletId: params.outletId,
            groupId: ownCheck.groupId,
          },
        })
      }
    }
  }, [dispatch, router, store])

  return mergeBack
}

export default usePayAndGoMergeBack
